<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg5628"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs5632"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath5644"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path5642" /></clipPath></defs><g
     id="g5634"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><path
       d="M 326.94,370.895 H 292.379 V 430.97 H 326.94 Z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path5636" /><g
       id="g5638"><g
         id="g5640"
         clip-path="url(#clipPath5644)"><g
           id="g5646"
           transform="translate(220.3804,370.8945)"><path
             d="m 0,0 h 144.016 c 11.046,0 20,-8.954 20,-20 V -121.525 H -171.137 V -20 c 0,11.046 8.955,20 20,20 h 10.6"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5648" /></g><g
           id="g5650"
           transform="translate(395.7363,221.874)"><path
             d="M 0,0 -11.34,27.495 H -346.493 L -388.236,-73.724 H -42.618"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5652" /></g><g
           id="g5654"
           transform="translate(426.1406,44.2402)"><path
             d="m 0,0 v -16.74 c 0,-11.046 -8.954,-20 -20,-20 h -378.641 c -11.046,0 -20,8.954 -20,20 v 120.65 h 345.619"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5656" /></g><g
           id="g5658"
           transform="translate(391.1406,87.7793)"><path
             d="m 0,0 v -35.279 c 0,-5.523 -4.478,-10 -10,-10 h -328.641 c -5.523,0 -10,4.477 -10,10 v 50.65 c 0,5.523 4.477,10 10,10 h 312.12"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5660" /></g><g
           id="g5662"
           transform="translate(209.6201,77.8252)"><path
             d="M 0,0 H 14.4"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5664" /></g><g
           id="g5666"
           transform="translate(94.874,286.0117)"><path
             d="M 0,0 H 108.72"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5668" /></g><g
           id="g5670"
           transform="translate(79.8438,467.7354)"><path
             d="m 0,0 c 16.9,0 30.6,-13.7 30.6,-30.601 v -151.123 h 77.58 V -30.601 C 108.18,-13.7 94.48,0 77.58,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5672" /></g><g
           id="g5674"
           transform="translate(79.8438,467.7354)"><path
             d="M 0,0 C -16.9,0 -30.6,-13.7 -30.6,-30.601 V -61.08 h 61.2 v 30.479 C 30.6,-13.7 16.9,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5676" /></g><g
           id="g5678"
           transform="translate(116.1553,216.5195)"><path
             d="M 0,0 H 15.3"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5680" /></g><g
           id="g5682"
           transform="translate(178.165,216.5195)"><path
             d="M 0,0 H 15.3"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5684" /></g><g
           id="g5686"
           transform="translate(240.1753,216.5195)"><path
             d="M 0,0 H 15.3"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5688" /></g><g
           id="g5690"
           transform="translate(302.1855,216.5195)"><path
             d="M 0,0 H 15.3"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5692" /></g><g
           id="g5694"
           transform="translate(116.1553,183.335)"><path
             d="M 0,0 H 15.3"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5696" /></g><g
           id="g5698"
           transform="translate(178.165,183.335)"><path
             d="M 0,0 H 15.3"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5700" /></g><g
           id="g5702"
           transform="translate(240.1753,183.335)"><path
             d="M 0,0 H 15.3"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5704" /></g><g
           id="g5706"
           transform="translate(302.1855,183.335)"><path
             d="M 0,0 H 15.3"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5708" /></g><g
           id="g5710"
           transform="translate(374.3965,430.9697)"><path
             d="m 0,0 h -128.977 c -5.523,0 -10,4.478 -10,10 v 53.53 c 0,5.523 4.477,10 10,10 H 0 c 5.523,0 10,-4.477 10,-10 V 10 C 10,4.478 5.523,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5712" /></g><g
           id="g5714"
           transform="translate(338.4902,286.0117)"><path
             d="m 0,0 h -93.07 c -5.523,0 -10,4.478 -10,10 v 28.24 c 0,5.524 4.477,10 10,10 H 0 c 5.522,0 10,-4.476 10,-10 V 10 C 10,4.478 5.522,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5716" /></g><g
           id="g5718"
           transform="translate(138.3003,406.6553)"><path
             d="M 0,0 H 18.96"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5720" /></g><g
           id="g5722"
           transform="translate(138.3003,370.8945)"><path
             d="M 0,0 H 18.96"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5724" /></g><g
           id="g5726"
           transform="translate(138.3003,335.1338)"><path
             d="M 0,0 H 18.96"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5728" /></g><g
           id="g5730"
           transform="translate(262.9443,467.7354)"><path
             d="M 0,0 H 93.928"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5732" /></g><g
           id="g5734"
           transform="translate(488.0078,200.8203)"><path
             d="m 0,0 c 10.323,-12.95 16.492,-29.357 16.492,-47.205 0,-41.858 -33.932,-75.79 -75.79,-75.79 -41.857,0 -75.79,33.932 -75.79,75.79 0,41.857 33.933,75.79 75.79,75.79 12.568,0 24.42,-3.059 34.855,-8.473"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5736" /></g><g
           id="g5738"
           transform="translate(411.4951,136.418)"><path
             d="m 0,0 c 0,-9.508 7.707,-17.215 17.215,-17.215 9.508,0 17.215,7.707 17.215,17.215 0,9.508 -7.707,17.215 -17.215,17.215 V 17.179 C 7.707,17.179 0,24.887 0,34.395 c 0,9.506 7.707,17.214 17.215,17.214 9.508,0 17.215,-7.708 17.215,-17.214"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5740" /></g><g
           id="g5742"
           transform="translate(428.71,203.4648)"><path
             d="M 0,0 V -15.438"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5744" /></g><g
           id="g5746"
           transform="translate(428.71,119.2031)"><path
             d="M 0,0 V -15.438"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path5748" /></g></g></g></g></svg>
</template>
